import styled from '@emotion/styled';

const Icon = styled.div({
  display: 'flex',
  flexShrink: 0,
  lineHeight: 0,
  fontSize: '1.8rem',
});

export const S = {
  Icon,
} as const;
